// @ts-check
import moment from 'moment';

export class GroupMembershipModel {
  constructor({ OrganizationId, GroupId, PatientId, RoleId, JoinedDate }) {
    this._modelName = 'Membership';
    this.OrganizationId = OrganizationId;
    this.GroupId = GroupId;
    this.PatientId = PatientId;
    this.RoleId = RoleId;
    this.JoinedDate = JoinedDate ? moment(JoinedDate) : null;
  }

  static get validations() {
    return {};
  }

  __copy() {
    return JSON.parse(JSON.stringify(this));
  }
}

export default GroupMembershipModel;
